import React from 'react';

import {SchemaTagForTableDisplay} from 'schemas/tags/TagValue';
import TableCellWithTooltip, {
  NO_VALUE_TOOLTIP_TITLE,
} from 'ui-library/scrollable/table-cells/TableCellWithTooltip';
import TextValue from 'ui-library/TextValue';

interface UnitAwareScrollableTableCellTagValueProps {
  className?: string;
  tag: SchemaTagForTableDisplay;
}

export default function UnitAwareScrollableTableCellTagValue({
  className,
  tag,
}: UnitAwareScrollableTableCellTagValueProps): JSX.Element {
  const textValue = tag.value ? `${tag.value} ${tag.tagSchemaField.unitSymbol}` : null;
  const tooltip = textValue != null ? textValue : NO_VALUE_TOOLTIP_TITLE;
  return (
    <TableCellWithTooltip className={className} tooltipTitle={tooltip}>
      <TextValue value={textValue} isFaded={tag.isFiller} />
    </TableCellWithTooltip>
  );
}
